import { makeStyles, Typography, Box, Grid } from "@material-ui/core";

import { Toggle } from "../toggle";
import { ShaDowBox } from "../boxes";
import { NoDataCard } from "./noDataCard";
import { COLORS } from "../../theme/colors";
import { StackedAreaChart } from "../charts";
import { nKilowattFormatter } from "../../services";

const useStyles = makeStyles(() => ({
  bold: {
    fontWeight: 700,
  },
  consumptionBlock: {
    position: "absolute",
    top: "45%",
    left: "-18px",
    transform: "translateY(-50%)",
  },
  consumption: {
    color: COLORS.darks[0][50],
    fontSize: 10,
    transform: "rotate(-90deg)",
  },
}));

export const PowerConsumptionOverTime = ({
  chartData,
  chartAreas,
  title,
  monthlyAvg,
  previousYearConsumption,
  toggleOption,
  toggleOptions,
  handleChange,
}) => {
  const classes = useStyles();

  if (!chartData.length) return <NoDataCard title={title} type="area" />;

  return (
    <ShaDowBox fullHeight>
      <Box style={{ padding: 24 }}>
        <Grid container justifyContent="space-between">
          <Typography variant="h4">{title}</Typography>
          {toggleOptions ? (
            <Toggle
              value={toggleOption}
              options={toggleOptions}
              onChanged={handleChange}
              styles={{ width: 26, fontSize: 12 }}
            />
          ) : null}
        </Grid>
        <Typography>
          {monthlyAvg && (
            <span>
              <span className={classes.bold}>Monthly avg.</span> {nKilowattFormatter(monthlyAvg)};
            </span>
          )}
          <span className={classes.bold}> {new Date().getUTCFullYear() - 1} total</span>{" "}
          {nKilowattFormatter(previousYearConsumption)}
        </Typography>
        <Box style={{ marginTop: 24, position: "relative" }}>
          <Box className={classes.consumptionBlock}>
            <Typography className={classes.consumption}>kWh</Typography>
          </Box>
          <StackedAreaChart
            height={200}
            data={chartData}
            areas={chartAreas}
            units={{
              consumption: "kwh",
            }}
            onlyLeftRightXAxis
            hideXAxis={true}
            hideSumOnToolTip
            yAxisDy={10}
            yAxisDx={30}
            yAxisWidth={1}
            xAxisPadding={{ left: 30 }}
          />
        </Box>
      </Box>
    </ShaDowBox>
  );
};
